import React, { useEffect, useState } from "react";
import InvalidMessage from "venuescanner-js/react/components/Form/Notifications/InvalidMessage";
import placeholders from "venuescanner-js/react/components/Form/copy/placeholders";
import classes from "./Input.module.scss";
import IntlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import cl from "classnames";

function Input(props) {
  const {
    errors = {},
    touched = {},
    label,
    name,
    register = () => {},
    value,
    handleChange,
  } = props;
  const [input, setInput] = useState();
  let widget;
  useEffect(() => {
    if (input) {
      // console.log(input)
      register(input);
      widget = IntlTelInput(input, {
        initialCountry: "gb",
        separateDialCode: true,
        dropdownContainer: document.body,
        preferredCountries: ["fr", "us", "gb"],
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.js",
      });
    }
  }, [input]);

  return (
    <div
      className={cl([
        classes.input,
        { "form-error": errors[name] && (!touched || touched[name]) },
      ])}
    >
      {label && <label>{label}</label>}
      <input
        name={name}
        ref={setInput}
        placeholder={placeholders[name]}
        onChange={(e) => {
          handleChange(e);
        }}
        defaultValue={value || ""}
      />
      <InvalidMessage error={(!touched || touched[name]) && errors[name]} />
    </div>
  );
}

export default Input;
